import React, {useState, useContext, useRef, useEffect} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FirmwareContext } from "../../context/FirmwareContext";
import "./navbar.css";
import logo from "../../assets/nkrep.png";

const Navbar = () => {

  const [ searchTerm, setSearchTerm ] = useState("");
  const [ filteredResults, setFilteredResults ] = useState([]);
  const [ onFocus, setOnFocus ] = useState(false);
  const [ isSearchOpen, setIsSearchOpen ] = useState(false);
  
  const firmwares = useContext(FirmwareContext);
  const navigate = useNavigate();
  const location = useLocation();
  const searchRef = useRef(null);

  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term.length > 0) {
      const results = firmwares
        .filter(fw => 
          fw.brand.toLowerCase().includes(term) || fw.model.toLowerCase().includes(term)
        )
        .sort((a, b) => a.model.localeCompare(b.model));
        setFilteredResults(results);
        setOnFocus(true);
    } else {
      setFilteredResults([]);
      setOnFocus(false);
    }
  };

  const handleResultClick = ( brand, model, instalation ) => {
    setSearchTerm("");
    setFilteredResults([]);
    setOnFocus(false);
    navigate(`/brands/${encodeURIComponent(brand)}/${encodeURIComponent(model)}/${encodeURIComponent(instalation)}`);
  };

  const handleBlur = (e) => {
    if (!searchRef.current || !searchRef.current.contains(e.relatedTarget)) {
      setOnFocus(false);
    }
  }

  const handleSearchOpen = () => {
    setIsSearchOpen(!isSearchOpen);
  }

  useEffect(() => {
    setSearchTerm("");
    setFilteredResults([]);
    setOnFocus(false);
    setIsSearchOpen(false);
  }, [location.pathname]);


  return (
    <section className="navbar-container">
      <div className={`logo ${isSearchOpen ? "hidden" : ""}`}>
        <Link to="/">
          <img src={logo} alt="" className="logo" />
        </Link>
      </div>

      <div className={`search-container ${!isSearchOpen ? "hidden" : ""}`}>

        <div className={`search ${!isSearchOpen ? "hidden" : ""}`}>
          <input 
          onFocus={() => setOnFocus(true)}
          onBlur={handleBlur}
          className={`search-input ${!isSearchOpen ? "hidden" : ""}`}
          type="text" 
          placeholder="Buscar Firmware por marca o modelo..." 
          value={searchTerm}
          onChange={handleSearchChange}
          />
      
        </div>

        {onFocus && filteredResults.length > 0 && (
            <ul className={`search-results ${onFocus ? "focus" : "no-focus"}`} tabIndex="-1" onBlur={handleBlur}>
              {filteredResults.map((fw, index) => (
                <li
                className="search-item"
                key={index}
                onMouseDown={() => handleResultClick(fw.brand, fw.model, fw.instalation)}
                >
                  {fw.brand} {fw.model} ({fw.instalation})
                </li>
              ))}
            </ul>
        )}

      </div>

      <div className="toggle-search-button" onClick={handleSearchOpen}>
        {isSearchOpen ? "✖" : "🔍︎"}
      </div>
      
    </section>
  );
};

export default Navbar;